module.exports = __webpack_public_path__ + "img/k-min.af54c1a7.jpg";